import { render, staticRenderFns } from "./MasterSVG.vue?vue&type=template&id=b74f0722&scoped=true"
import script from "./MasterSVG.vue?vue&type=script&lang=js"
export * from "./MasterSVG.vue?vue&type=script&lang=js"
import style0 from "./MasterSVG.vue?vue&type=style&index=0&id=b74f0722&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b74f0722",
  null
  
)

export default component.exports